import React from "react";
import Swiper, { Navigation, Pagination } from "swiper";
import { useContext, useEffect, useState } from "react";
import SimpleContext from "./../context/SimpleContext";
import { useHistory } from "react-router";
import "./UserPonits.css";
import Carousel from "nuka-carousel";
const UserPonits = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();

  useEffect(() => {
    context.callPoints();
  }, []);

  return (
    <div className="userPoint">
      <header>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            paddingRight: "10px",
          }}
        >
          <img
            style={{ width: "13px" }}
            alt="آیکون بازگشت به صفحه قبل"
            onClick={() => history.go(-1)}
            src="/images/right.png"
          />
        </div>

        <h1 style={{ margin: "0", textAlign: "center", fontSize: "15px" }}>
          جزئیات امتیازها
        </h1>

        {Object.values(context.FestivalDataPoints).length > 0 &&
          Object.values(context.FestivalDataPoints.festivalValue).length >
            0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: "10px",
              }}
              className="userPointSum"
            >
              <img style={{ width: "60px" }} src="/images/seke.png" />
              <span>{context.FestivalDataPoints.festivalValue.pointSum}</span>
            </div>
          )}
      </header>

      <div>
        <Carousel
          speed={"2000"}
          autoplay={true}
          animation="fade"
          cellAlign="center"
          autoplayInterval={3000}
          renderCenterLeftControls={({ previousSlide }) => (
            <button className="buttonRightSlider" onClick={previousSlide}>
              <i className="fa fa-chevron-left" />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button className="buttonLeftSlider" onClick={nextSlide}>
              <i className="fa fa-chevron-right" />
            </button>
          )}
        >
          {Object.values(context.FestivalDataPoints).length > 0 &&
            context.FestivalDataPoints.banners.length > 0 &&
            context.FestivalDataPoints.banners.map((i, j) => (
              <img className="sliderImg" key={j} alt={i.title} src={i.image} />
            ))}
        </Carousel>

        

        {/* امتیازات */}
        {Object.values(context.FestivalDataPoints).length > 0 &&
          Object.values(context.FestivalDataPoints.detail).length > 0 &&
          context.FestivalDataPoints.detail.festivalPoint.length > 0 &&
          context.FestivalDataPoints.detail.festivalPoint.map((i) => (
            <div className="userPointS">
              <span className="scoreCost">{i.TotalAmount}</span>
              <span className="scorePoint">{`${i.point}`}</span>
              <span className="scoreTime">
              {i.OrderDate.split("\n").map((item, key) => {
                    return <span key={key}>{item}</span>;
                  })}
              </span>
              {/* <span className="scoreTime">{i.OrderDate}</span> */}
            </div>
          ))}
      </div>
    </div>
  );
};

export default UserPonits;
